import React from "react"

function IconMinus({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="minus"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-minus"
      {...props}
    >
      <path
        d="M19.636 11.345a.655.655 0 0 1 .107 1.301l-.107.009H4.364a.655.655 0 0 1-.107-1.301l.107-.009h15.272z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconMinus
